export default __webpack_public_path__ + "static/media/horse_box_icon.d164ec72.svg";